import { cloneDeep } from "lodash-es";

import {
  LOGOUT,
  FETCH_SESSIONS_LIST,
  CANCEL_UPCOMING_SESSION,
  UPDATE_SESSION_OBJ,
  FETCH_PROVIDER_PROFILE,
  FETCH_PROVIDER_SCHEDULE,
  PROVIDER_PROFILE_LOADING,
  PROVIDER_MOBILE_VERIFIED,
  FETCH_PRESCRIPTIONS,
  SET_PRESCRIPTION_META,
  SESSIONS_LIST_LOADING,
  SESSION_COUNT,
  SET_MEDICINES,
  SET_HAS_REFERRAL,
  SET_HAS_INVESTIGATION,
  SET_ADD_MEDICINE_SCREEN_VISIBLE,
  LOADING_PRESCRIPTIONS_META,
  SET_PRESCRIPTION_UPDATE_TRIGGER,
  SHOW_ADD_PRESCRIPTION_MODAL,
  MONTHLY_SCHEDULE,
  DAILY_SCHEDULE,
  EDIT_DAILY_SCHEDULE,
  BASE_WEEK_SCHEDULE,
  EDIT_BASE_WEEK_SCHEDULE,
  CLEAR_BASE_WEEK_SCHEDULE,
  UPDATE_LOCAL_PROVIDER_PROFILE,
  RESET_LOCAL_PROVIDER_PROFILE,
  UPDATE_REMOTE_PROVIDER_PROFILE,
  LOADING_SESSION_ACTIONS,
} from "../Actions/types";

const INITIAL_STATE = {
  sessions: [],
  prescriptions: [],
  providerProfile: {},
  localProviderProfile: {},
  schedules: {},
  providerProfileLoading: false,
  loadingSessions: false,
  loadingSessionActions: false,
  loadingPrescriptionsMeta: false,
  prescriptionsMeta: null,
  medicines: [],
  hasReferral: false,
  hasInvestigation: false,
  isAddMedicineScreenVisible: false,
  triggerPrescriptionUpdate: false,
  showAddPrescriptionModal: false,
  monthlySchedule: {
    loading: false,
    data: [],
  },
  dailySchedule: {
    loading: false,
    remoteData: {
      date: "",
      online_slots: [],
      offline_slots: [],
      both_slots: [],
      booked_slots: [],
      blocked_slots: [],
    },
    localData: {
      date: "",
      blocked_slots: [],
      online_slots: [],
      offline_slots: [],
      both_slots: [],
      booked_slots: [],
    },
    unavailable_slots: null,
  },
  baseWeekSchedule: {
    loading: false,
    remoteData: {
      provider_online_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
      provider_offline_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
      provider_both_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
    },
    localData: {
      provider_online_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
      provider_offline_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
      provider_both_schedules: {
        monday: [],
        tuesday: [],
        wednesday: [],
        thursday: [],
        friday: [],
        saturday: [],
        sunday: [],
      },
    },
  },
};

let therapistReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SESSIONS_LIST_LOADING:
      return { ...state, loadingSessions: action.payload };

    case FETCH_SESSIONS_LIST:
      return { ...state, sessions: action.payload };

    case FETCH_PRESCRIPTIONS:
      return { ...state, prescriptions: action.payload.data };

    case LOADING_PRESCRIPTIONS_META:
      return { ...state, loadingPrescriptionsMeta: action.payload };

    case SET_PRESCRIPTION_META:
      return { ...state, prescriptionsMeta: action.payload.data };

    case SET_PRESCRIPTION_UPDATE_TRIGGER:
      return { ...state, triggerPrescriptionUpdate: action.payload };

    case SHOW_ADD_PRESCRIPTION_MODAL:
      return { ...state, showAddPrescriptionModal: action.payload };

    case CANCEL_UPCOMING_SESSION:
      const updatedSessions = state.sessions.filter(
        session => session.id !== action.payload.bookingID
      );
      return { ...state, sessions: updatedSessions };

    case LOADING_SESSION_ACTIONS:
      return { ...state, loadingSessionActions: action.payload };

    case UPDATE_SESSION_OBJ:
      const sessionIndex = state.sessions.findIndex(
        session => session.id === action.payload.id
      );

      if (sessionIndex !== -1) {
        let updatedSessions = [...state.sessions];
        updatedSessions[sessionIndex] = action.payload;
        return { ...state, sessions: updatedSessions };
      } else {
        return state;
      }

    case PROVIDER_PROFILE_LOADING:
      return { ...state, providerProfileLoading: action.payload };

    case FETCH_PROVIDER_PROFILE:
      return {
        ...state,
        providerProfile: {
          ...state.providerProfile,
          ...action.payload,
        },
      };

    case UPDATE_LOCAL_PROVIDER_PROFILE:
      return {
        ...state,
        localProviderProfile: {
          ...state.localProviderProfile,
          ...action.payload,
        },
      };

    case UPDATE_REMOTE_PROVIDER_PROFILE:
      return {
        ...state,
        providerProfile: {
          ...state.providerProfile,
          ...action.payload,
        },
      };

    case RESET_LOCAL_PROVIDER_PROFILE:
      return {
        localProviderProfile: {},
      };

    case SESSION_COUNT:
      return {
        ...state,
        cancelledSession: action.payload.cancelled,
        scheduledSession: action.payload.scheduled,
      };

    case FETCH_PROVIDER_SCHEDULE:
      return {
        ...state,
        schedules: action.payload,
      };

    case PROVIDER_MOBILE_VERIFIED:
      return {
        ...state,
        providerProfile: {
          ...state.providerProfile,
          therapistMobileVerified: action.payload || false,
        },
      };

    case SET_MEDICINES:
      return {
        ...state,
        medicines: action.payload,
      };

    case SET_HAS_REFERRAL:
      return {
        ...state,
        hasReferral: action.payload,
      };

    case SET_HAS_INVESTIGATION:
      return {
        ...state,
        hasInvestigation: action.payload,
      };

    case SET_ADD_MEDICINE_SCREEN_VISIBLE:
      return {
        ...state,
        isAddMedicineScreenVisible: action.payload,
      };

    case MONTHLY_SCHEDULE:
      return {
        ...state,
        monthlySchedule: {
          loading: action.payload.loading,
          data: action.payload.data,
        },
      };

    case DAILY_SCHEDULE:
      const apiData = action.payload.data;
      return {
        ...state,
        dailySchedule: {
          loading: action.payload.loading,
          remoteData: apiData,
          localData: cloneDeep(apiData),
        },
      };

    case EDIT_DAILY_SCHEDULE:
      return {
        ...state,
        dailySchedule: {
          ...state.dailySchedule,
          localData: {
            ...state.dailySchedule.localData,
            online_slots: action.payload.online_slots,
            offline_slots: action.payload.offline_slots,
            both_slots: action.payload.both_slots,
            blocked_slots: action.payload.blocked_slots,
          },
          unavailable_slots: action.payload.unavailable_slots,
        },
      };

    case BASE_WEEK_SCHEDULE:
      return {
        ...state,
        baseWeekSchedule: {
          loading: action.payload.loading,
          remoteData: action.payload.data,
          localData: action.payload.data,
        },
      };

    case EDIT_BASE_WEEK_SCHEDULE:
      return {
        ...state,
        baseWeekSchedule: {
          ...state.baseWeekSchedule,
          localData: {
            provider_online_schedules: {
              ...state.baseWeekSchedule.localData.provider_online_schedules,
              [action.payload.day]: action.payload.provider_online_schedules,
            },
            provider_offline_schedules: {
              ...state.baseWeekSchedule.localData.provider_offline_schedules,
              [action.payload.day]: action.payload.provider_offline_schedules,
            },
            provider_both_schedules: {
              ...state.baseWeekSchedule.localData.provider_both_schedules,
              [action.payload.day]: action.payload.provider_both_schedules,
            },
          },
        },
      };

    case CLEAR_BASE_WEEK_SCHEDULE:
      return {
        ...state,
        baseWeekSchedule: {
          ...state.baseWeekSchedule,
          localData: {
            provider_online_schedules: {
              monday: [],
              tuesday: [],
              wednesday: [],
              thursday: [],
              friday: [],
              saturday: [],
              sunday: [],
            },
            provider_offline_schedules: {
              monday: [],
              tuesday: [],
              wednesday: [],
              thursday: [],
              friday: [],
              saturday: [],
              sunday: [],
            },
            provider_both_schedules: {
              monday: [],
              tuesday: [],
              wednesday: [],
              thursday: [],
              friday: [],
              saturday: [],
              sunday: [],
            },
          },
        },
      };

    case LOGOUT:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default therapistReducer;
